"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowActionContextSchema = exports.workflowActionRequestSchema = exports.workflowActionQuerySchema = exports.workflowActionResourceTypeSchema = exports.workflowPipelineResponseSchema = exports.workflowPipelineColumnSchema = exports.workflowPipelineQuerySchema = exports.workflowPipelineItemSchema = exports.workflowPipelineResourceSchema = exports.workflowPipelineViewSchema = exports.workflowPipelineStageSchema = exports.workflowQuickActionSchema = void 0;
const zod_1 = require("zod");
const job_1 = require("./job");
const pending_job_pipeline_1 = require("./pending-job-pipeline");
exports.workflowQuickActionSchema = zod_1.z.enum([
    "FOLLOW_UP",
    "ASSIGN_OWNER",
    "HOLD",
    "RESUME",
]);
const pagination_1 = require("./pagination");
exports.workflowPipelineStageSchema = zod_1.z.enum([
    "NEW_REQUEST",
    "CONTACTED",
    "ESTIMATE_NEEDED",
    "AWAITING_CUSTOMER",
    "APPROVED",
    "READY_TO_SCHEDULE",
    "SCHEDULED",
    "IN_PROGRESS",
    "TO_INVOICE",
    "AWAITING_PAYMENT",
    "PAID",
    "ON_HOLD",
    "CLOSED",
]);
exports.workflowPipelineViewSchema = zod_1.z.enum([
    "ACTIVE",
    "ALL",
    "LEADS",
    "SALES",
    "OPERATIONS",
    "BILLING",
    "CLOSED",
]);
exports.workflowPipelineResourceSchema = zod_1.z.object({
    type: zod_1.z.enum(["LEAD", "ESTIMATE", "JOB", "INVOICE"]),
    id: zod_1.z.string().uuid(),
    label: zod_1.z.string().min(1).max(200),
});
exports.workflowPipelineItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    stage: exports.workflowPipelineStageSchema,
    underlyingStage: exports.workflowPipelineStageSchema,
    status: zod_1.z.string().min(1),
    title: zod_1.z.string().min(1).max(240),
    customerName: zod_1.z.string().min(1).max(320),
    resource: exports.workflowPipelineResourceSchema,
    resources: zod_1.z.array(exports.workflowPipelineResourceSchema),
    priority: job_1.jobPrioritySchema,
    ownerName: zod_1.z.string().nullable(),
    // Actual assignment source; for an empty assignment, the leaf's expected role.
    // Optional for compatibility with existing v1 responses.
    ownerRole: zod_1.z
        .enum(["OFFICE_OWNER", "TECHNICIAN", "ESTIMATE_ASSIGNEE", "LEAD_ASSIGNEE"])
        .nullable()
        .optional(),
    amountCents: zod_1.z.number().int().nonnegative().nullable(),
    balanceCents: zod_1.z.number().int().nonnegative().nullable(),
    paymentStatus: zod_1.z.enum([
        "NOT_INVOICED",
        "DRAFT",
        "UNPAID",
        "PARTIALLY_PAID",
        "PAID",
        "PAST_DUE",
        "VOID",
    ]),
    followUpAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    followUpOverdue: zod_1.z.boolean(),
    holdReason: zod_1.z.string().nullable(),
    pendingItemId: zod_1.z.string().uuid().nullable(),
    quickActions: zod_1.z.array(exports.workflowQuickActionSchema).default([]),
    officeOwnerName: zod_1.z.string().nullable().default(null),
    appointmentAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    timezone: zod_1.z.string(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.workflowPipelineQuerySchema = pagination_1.paginationQuerySchema.extend({
    search: zod_1.z.string().trim().max(160).optional(),
    view: exports.workflowPipelineViewSchema.default("ACTIVE"),
    stage: exports.workflowPipelineStageSchema.optional(),
    followUp: zod_1.z.enum(["OVERDUE", "NONE"]).optional(),
    locationId: zod_1.z.string().uuid().optional(),
});
exports.workflowPipelineColumnSchema = zod_1.z.object({
    stage: exports.workflowPipelineStageSchema,
    total: zod_1.z.number().int().nonnegative(),
    items: zod_1.z.array(exports.workflowPipelineItemSchema),
    pageInfo: pagination_1.pageInfoSchema,
});
exports.workflowPipelineResponseSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(1),
    multiLocationEnabled: zod_1.z.boolean().optional(),
    location: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        name: zod_1.z.string(),
        timezone: zod_1.z.string(),
    }),
    columns: zod_1.z.array(exports.workflowPipelineColumnSchema),
    total: zod_1.z.number().int().nonnegative(),
    refreshedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.workflowActionResourceTypeSchema = zod_1.z.enum([
    "LEAD",
    "ESTIMATE",
    "JOB",
]);
exports.workflowActionQuerySchema = zod_1.z.object({
    locationId: zod_1.z.string().uuid(),
});
const workflowActionVersion = {
    expectedUpdatedAt: zod_1.z.string().datetime({ offset: true }),
};
exports.workflowActionRequestSchema = zod_1.z.discriminatedUnion("action", [
    zod_1.z
        .object({
        ...workflowActionVersion,
        action: zod_1.z.literal("FOLLOW_UP"),
        followUpAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    })
        .strict(),
    zod_1.z
        .object({
        ...workflowActionVersion,
        action: zod_1.z.literal("ASSIGN_OWNER"),
        ownerMembershipId: zod_1.z.string().uuid().nullable(),
    })
        .strict(),
    zod_1.z
        .object({
        ...workflowActionVersion,
        action: zod_1.z.literal("HOLD"),
        reasonCode: pending_job_pipeline_1.pendingJobPipelineReasonCodeSchema,
    })
        .strict(),
    zod_1.z.object({ ...workflowActionVersion, action: zod_1.z.literal("RESUME") }).strict(),
]);
exports.workflowActionContextSchema = zod_1.z.object({
    itemId: zod_1.z.string().uuid(),
    expectedUpdatedAt: zod_1.z.string().datetime({ offset: true }),
    followUpAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    ownerMembershipId: zod_1.z.string().uuid().nullable(),
    owners: zod_1.z.array(pending_job_pipeline_1.pendingJobPipelineOwnerSchema),
    holdReasonCode: pending_job_pipeline_1.pendingJobPipelineReasonCodeSchema.nullable(),
    resumeStage: pending_job_pipeline_1.pendingJobPipelineStageSchema.nullable(),
    availableActions: zod_1.z.array(exports.workflowQuickActionSchema),
    timezone: zod_1.z.string(),
});
//# sourceMappingURL=workflow-pipeline.js.map